import { permissionTree } from '@config/permissionTree';

// 获取所有权限字段的扁平列表
export const getAllPermissionKeys = () => {
    const keys = [];

    const traverse = (nodes) => {
        nodes.forEach(node => {
            keys.push(node.key);
            if (node.children && node.children.length > 0) {
                traverse(node.children);
            }
        });
    };

    traverse(permissionTree);
    return keys;
};

// 获取所有叶子节点（最终子节点）的key列表
export const getLeafPermissionKeys = () => {
    const leafKeys = [];

    const traverse = (nodes) => {
        nodes.forEach(node => {
            if (!node.children || node.children.length === 0) {
                // 这是叶子节点
                leafKeys.push(node.key);
            } else {
                // 这是父节点，继续遍历子节点
                traverse(node.children);
            }
        });
    };

    traverse(permissionTree);
    return leafKeys;
};

// 获取所有父级节点的key列表
export const getParentPermissionKeys = () => {
    const parentKeys = [];

    const traverse = (nodes) => {
        nodes.forEach(node => {
            if (node.children && node.children.length > 0) {
                // 这是父节点
                parentKeys.push(node.key);
                traverse(node.children);
            }
        });
    };

    traverse(permissionTree);
    return parentKeys;
};

// 权限值映射
export const PERMISSION_VALUES = {
    DISABLED: 0,     // 禁用
    ENABLED: 1,      // 启用（只读权限）
    WRITE_ACCESS: 2, // 可写权限
    FULL_ACCESS: 3   // 完全访问权限
}; 